/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  const REFRESH_PAGE_ON_CART_ADD = true;
  
  /**
   * Check if Rebuy bundle builder is present on the page
   * Looks for .rebuy-bundle-builder__cta-container for up to 2 minutes after page load
   */
  function checkForRebuyBundleBuilder(callback) {
    const MAX_CHECK_TIME = 240000000;
    const CHECK_INTERVAL = 100;
    const startTime = Date.now();
    
    function check() {
      const bundleBuilder = document.querySelector('.rebuy-bundle-builder__cta-container');
      const elapsed = Date.now() - startTime;
      
      if (bundleBuilder) {
        callback(true);
        return;
      }
      
      if (elapsed < MAX_CHECK_TIME) {
        setTimeout(check, CHECK_INTERVAL);
      } else {
        callback(false);
      }
    }
    
    check();
  }
  
  /**
   * Check if we should enable Rebuy tracking based on URL/page conditions
   */
  function shouldEnableRebuyTracking() {
    const bodyId = document.body.id;
    const currentUrl = window.location.href.toLowerCase();
    const currentPath = window.location.pathname.toLowerCase();
    
    const isBundleUrl = currentUrl.includes('build-a-bundle-save-up-to-30-off') || 
                        currentPath.includes('build-a-bundle-save-up-to-30-off');
    
    const isBundleColorSelectPage = bodyId.includes('bundle-color-select') ||
                                    bodyId.includes('bundle-color') ||
                                    currentPath.includes('bundle-color-select') ||
                                    currentPath.includes('bundle-color');
    return isBundleUrl || isBundleColorSelectPage;
  }
  
  /**
   * Track Rebuy cart changes for Bundle Color Select template
   * Only runs if template matches or URL contains specific string
   */
  function initRebuyCartTracking() {
    function observeRebuyCart() {
      const rebuyCart = document.getElementById('rebuy-cart');
      if (!rebuyCart) {
        setTimeout(observeRebuyCart, 1000);
        return;
      }
      const cartItemsContainer = rebuyCart.querySelector('[data-rebuy-component="cart-items"]');
      if (!cartItemsContainer) {
        return;
      }
      let refreshTimeout = null;
      let isRefreshing = false;
      
      function refreshThemeCart() {
        if (isRefreshing) {
          return Promise.resolve();
        }
        
        isRefreshing = true;
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        
        const cartDrawerSection = document.querySelector('[data-section-type="cart-drawer"]');
        if (cartDrawerSection) {
          const sectionId = cartDrawerSection.getAttribute('data-section-id');
          if (sectionId) {
            const cartUrl = window.theme?.routes?.cart_url || '/cart';
            const url = `${cartUrl}?section_id=${sectionId}`;
            
            return fetch(url)
              .then(response => {
                if (!response.ok) {
                  throw new Error('Cart drawer refresh failed');
                }
                return response.text();
              })
              .then(html => {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;
                const newSectionWrapper = tempDiv.querySelector('[data-section-type="cart-drawer"]');
                
                if (newSectionWrapper) {
                  cartDrawerSection.innerHTML = newSectionWrapper.innerHTML;
                  
                  const cartItems = document.querySelector('cart-items');
                  if (cartItems && typeof cartItems.enforceUpsellLimit === 'function') {
                    cartItems.enforceUpsellLimit();
                  }
                  
                  return new Promise(resolve => setTimeout(resolve, 500));
                }
                return Promise.resolve();
              })
              .catch(error => {
                return Promise.resolve();
              })
              .finally(() => {
                isRefreshing = false;
              });
          }
        }
        
        setTimeout(() => {
          isRefreshing = false;
        }, 1000);
        return Promise.resolve();
      }
      
      function refreshThemeCartAndOpen() {
        if (REFRESH_PAGE_ON_CART_ADD) {
          sessionStorage.setItem('rebuyCartRefresh', 'true');
          sessionStorage.setItem('rebuyCartRefreshTime', Date.now().toString());
          window.location.reload();
          return;
        }
        
        // Original behavior: AJAX refresh and open cart drawer
        if (refreshTimeout) {
          clearTimeout(refreshTimeout);
        }
        
        refreshTimeout = setTimeout(function() {
          const cartChangeHandler = function(event) {
            setTimeout(function() {
              const cartDrawer = document.querySelector('cart-drawer') || document.getElementById('cart-drawer');
              
              if (cartDrawer) {
                if (typeof cartDrawer.openCartDrawer === 'function') {
                  cartDrawer.openCartDrawer();
                } else {
                  document.dispatchEvent(new CustomEvent('theme:cart-drawer:show', { bubbles: true }));
                }
              }
            }, 500);
            
            document.removeEventListener('theme:cart:change', cartChangeHandler);
          };
          
          document.addEventListener('theme:cart:change', cartChangeHandler, { once: true });
          
          const fallbackTimeout = setTimeout(function() {
            const cartDrawer = document.querySelector('cart-drawer') || document.getElementById('cart-drawer');
            if (cartDrawer) {
              if (typeof cartDrawer.openCartDrawer === 'function') {
                cartDrawer.openCartDrawer();
              } else {
                document.dispatchEvent(new CustomEvent('theme:cart-drawer:show', { bubbles: true }));
              }
            }
            document.removeEventListener('theme:cart:change', cartChangeHandler);
          }, 2000);
          
          document.addEventListener('theme:cart:change', function() {
            clearTimeout(fallbackTimeout);
          }, { once: true });
          
          refreshThemeCart();
        }, 200);
      }
      
      let debounceTimer = null;
      let isInitialized = false;
      let pageReloadTimeout = null;
      
      // Function to set up page reload fallback (2 seconds after button click)
      function setupPageReloadFallback() {
        // Clear any existing timeout
        if (pageReloadTimeout) {
          clearTimeout(pageReloadTimeout);
        }
        
        pageReloadTimeout = setTimeout(function() {
          sessionStorage.setItem('rebuyCartRefresh', 'true');
          sessionStorage.setItem('rebuyCartRefreshTime', Date.now().toString());
          window.location.reload();
        }, 2000);
      }
      
      // Function to cancel page reload fallback (if MutationObserver succeeds)
      function cancelPageReloadFallback() {
        if (pageReloadTimeout) {
          clearTimeout(pageReloadTimeout);
          pageReloadTimeout = null;
        }
      }
      
      // Function to set up click listeners for rebuy-button elements
      function setupRebuyButtonListeners() {
        // Find the bundle builder container
        const bundleBuilderContainer = document.querySelector('.rebuy-bundle-builder__cta-container');
        
        if (!bundleBuilderContainer) {
          // Container not found, try again later
          return;
        }
        
        // Find rebuy buttons only inside the bundle builder container
        const rebuyButtons = bundleBuilderContainer.querySelectorAll('.rebuy-button');
        
        rebuyButtons.forEach(function(button) {
          // Check if listener already added
          if (button.hasAttribute('data-rebuy-tracking-listener')) {
            return;
          }
          
          button.setAttribute('data-rebuy-tracking-listener', 'true');
          
          button.addEventListener('click', function(e) {
            // Set up page reload fallback after 2 seconds
            setupPageReloadFallback();
            
            // Note: MutationObserver will detect the change and cancel the reload
            // If MutationObserver fails, the page will reload after 2 seconds
          });
        });
      }
      
      // Set up initial listeners
      setupRebuyButtonListeners();
      
      // Watch for dynamically added rebuy buttons inside bundle builder container
      const rebuyButtonObserver = new MutationObserver(function(mutations) {
        let shouldCheck = false;
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(function(node) {
              if (node.nodeType === 1) { // Element node
                // Check if the added node is inside bundle builder container
                const bundleBuilderContainer = document.querySelector('.rebuy-bundle-builder__cta-container');
                if (!bundleBuilderContainer) {
                  return;
                }
                
                // Check if the added node is a rebuy button or contains one
                const isRebuyButton = node.classList && node.classList.contains('rebuy-button');
                const containsRebuyButton = node.querySelector && node.querySelector('.rebuy-button');
                const isInsideContainer = bundleBuilderContainer.contains(node);
                
                if ((isRebuyButton || containsRebuyButton) && isInsideContainer) {
                  shouldCheck = true;
                }
              }
            });
          }
        });
        
        if (shouldCheck) {
          setupRebuyButtonListeners();
        }
      });
      
      // Observe the bundle builder container for new rebuy buttons
      const bundleBuilderContainer = document.querySelector('.rebuy-bundle-builder__cta-container');
      if (bundleBuilderContainer) {
        rebuyButtonObserver.observe(bundleBuilderContainer, {
          childList: true,
          subtree: true
        });
      } else {
        // If container doesn't exist yet, observe body and check for container
        rebuyButtonObserver.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
      
      const observer = new MutationObserver(function(mutations) {
        if (!isInitialized) {
          isInitialized = true;
          return;
        }
        
        // Clear any existing timer
        if (debounceTimer) {
          clearTimeout(debounceTimer);
        }
        
        // Debounce to avoid multiple rapid refreshes
        debounceTimer = setTimeout(function() {
          // Cancel page reload fallback since MutationObserver detected the change
          cancelPageReloadFallback();
          
          refreshThemeCartAndOpen();
        }, 100);
      });
      
      observer.observe(cartItemsContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeOldValue: true
      });
      
      const cartObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
            // Cart visibility changed
          }
        });
      });
      
      cartObserver.observe(rebuyCart, {
        attributes: true,
        attributeFilter: ['aria-hidden', 'class']
      });
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeRebuyCart);
    } else {
      observeRebuyCart();
    }
  }
  
  /**
   * Remove Rebuy injected style element and body classes
   * Watches for style#smart-cart-style and removes it when it appears
   * Also removes Rebuy visibility classes from body
   */
  function removeRebuyInjectedStyle() {
    function checkAndRemoveStyle() {
      const smartCartStyle = document.getElementById('smart-cart-style');
      
      if (smartCartStyle) {
        smartCartStyle.remove();
        return true;
      }
      
      return false;
    }
    
    checkAndRemoveStyle();
    
    const styleObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              if (node.id === 'smart-cart-style') {
                checkAndRemoveStyle();
                return;
              }
              
              const nestedStyle = node.querySelector ? node.querySelector('#smart-cart-style') : null;
              if (nestedStyle) {
                checkAndRemoveStyle();
              }
            }
          });
        }
      });
    });
    
    if (document.head) {
      styleObserver.observe(document.head, {
        childList: true,
        subtree: true
      });
    }
    
    if (document.body) {
      styleObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
    
    styleObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
    
    setInterval(function() {
      checkAndRemoveStyle();
    }, 100);
    
    function removeRebuyBodyClasses() {
      const rebuyClasses = [
        'rebuy-modal-visible',
        'rebuy-cart-visible',
        'rebuy-bundle-builder-container-visible'
      ];
      
      let removedAny = false;
      rebuyClasses.forEach(function(className) {
        if (document.body.classList.contains(className)) {
          document.body.classList.remove(className);
          removedAny = true;
        }
      });
      
      return removedAny;
    }
    
    removeRebuyBodyClasses();
    
    const bodyClassObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          removeRebuyBodyClasses();
        }
      });
    });
    
    if (document.body) {
      bodyClassObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
    
    setInterval(function() {
      removeRebuyBodyClasses();
    }, 100);
  }
  
  /**
   * Check if page was reloaded due to cart add
   * Returns true if sessionStorage indicates a cart refresh occurred
   */
  function wasReloadedFromCartAdd() {
    const refreshFlag = sessionStorage.getItem('rebuyCartRefresh');
    if (refreshFlag === 'true') {
      // Clear the flag so it doesn't trigger on subsequent reloads
      sessionStorage.removeItem('rebuyCartRefresh');
      const refreshTime = sessionStorage.getItem('rebuyCartRefreshTime');
      sessionStorage.removeItem('rebuyCartRefreshTime');
      return {
        wasReloaded: true,
        timestamp: refreshTime ? parseInt(refreshTime, 10) : null
      };
    }
    return { wasReloaded: false, timestamp: null };
  }
  
  /**
   * Open cart drawer after page load
   */
  function openCartDrawerOnLoad() {
    function attemptOpen() {
      const cartDrawer = document.querySelector('cart-drawer') || document.getElementById('cart-drawer');
      
      if (cartDrawer) {
        if (typeof cartDrawer.openCartDrawer === 'function') {
          cartDrawer.openCartDrawer();
        } else {
          document.dispatchEvent(new CustomEvent('theme:cart-drawer:show', { bubbles: true }));
        }
        return true;
      }
      return false;
    }
    
    // Try immediately
    if (attemptOpen()) {
      return;
    }
    
    // If not found, wait for DOM and try again
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(attemptOpen, 500);
      });
    } else {
      setTimeout(attemptOpen, 500);
    }
  }
  
  /**
   * Initialize Rebuy tracking and style removal if conditions are met
   */
  function initRebuyFeatures() {
    // Check if page was reloaded due to cart add
    const reloadInfo = wasReloadedFromCartAdd();
    if (reloadInfo.wasReloaded) {
      // Page was reloaded from cart add - open cart drawer
      openCartDrawerOnLoad();
    }
    
    const urlCondition = shouldEnableRebuyTracking();
    if (urlCondition) {
      // URL/page condition met, enable immediately
      removeRebuyInjectedStyle();
      initRebuyCartTracking();
    } else {
      // Check for bundle builder element for up to 2 minutes
      checkForRebuyBundleBuilder(function(found) {
        if (found) {
          removeRebuyInjectedStyle();
          initRebuyCartTracking();
        }
      });
    }
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRebuyFeatures);
  } else {
    initRebuyFeatures();
  }
})();